

import React, { createContext, useContext } from 'react';












const ThemeContext = createContext({
  primary: '#000'
});


export function ThemeProvider({
  children,
  primary
}) {
  return (
    <ThemeContext.Provider value={{ primary }}>
      {children}
    </ThemeContext.Provider>);

}

export function useThemeContext() {
  return useContext(ThemeContext);
}